// import authService from '../services/auth.service';
import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  AUTH_STORAGE,
  AUTH_TOKEN,
  USER_ID,
  USER_NAME,
  AUTH_USER,
} from "../constants/AuthConstant";
import AuthService from "services/AuthService";
import DashboardConfigService from "../services/dashboardConfigService";

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export const useAuth = create(
  persist(
    (set, get) => ({
      loading: false,
      message: "",
      showMessage: false,
      userId: localStorage.getItem(USER_ID),
      username: localStorage.getItem(USER_NAME),
      redirect: "/",
      token: localStorage.getItem(AUTH_TOKEN),

      showAuthMessage: (message) => {
        set({ message, showMessage: true, loading: false });
      },
      showLoading: () => {
        set({ loading: true });
      },
      hideAuthMessage: () => {
        set({ message: "", showMessage: false });
      },
      authenticated: (token) => {
        set({ loading: false, redirect: "/app/home", token: token });
      },
      login: async (body) => {
        set({ loading: true, showMessage: false });

        try {
          const { data, status } = await AuthService.login(body);
          if (status !== 200) {
            set({ message: data.detail, showMessage: true });
            return;
          }
          const parsed = parseJwt(data);

          const userId =
            parsed[
              "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
            ];
          const userLogin = parsed.nameid;

          if (!userId) {
            console.error(
              "Não foi possível encontrar o ID do usuário no token JWT:",
              parsed
            );
            set({ message: "Falha ao obter ID do usuário", showMessage: true });
            return;
          }

          console.log("Token JWT decodificado:", {
            userId: userId,
            login: userLogin,
            name: parsed.name,
          });

          // Objeto auth_user para compatibilidade com o DashboardService
          const authUserObj = {
            user: {
              id: userId,
              name: parsed.name,
              login: userLogin,
            },
            token: data,
          };

          // Salvar no localStorage como auth_user
          window.localStorage.setItem(AUTH_USER, JSON.stringify(authUserObj));

          set({ token: data, userId: userId, username: parsed.name });
          window.localStorage.setItem(AUTH_TOKEN, data);
          window.localStorage.setItem(USER_ID, userId);
          window.localStorage.setItem(USER_NAME, parsed.name);

          // Verificar se o usuário tem uma configuração de dashboard
          try {
            const config = await DashboardConfigService.getMyDashboardConfig();
            if (!config || !config.data) {
              // Se não tiver configuração, criar uma padrão
              await DashboardConfigService.createDefaultConfig();
            }
          } catch (error) {
            console.error(
              "Erro ao verificar/criar configuração do dashboard:",
              error
            );
            // Não bloqueia o login se houver erro na configuração do dashboard
          }

          window.location.href = "/dashboard2";
        } catch (e) {
          set({ message: e?.response?.data?.message, showMessage: true });
        } finally {
          set({
            loading: false,
          });
        }
      },
      logout: () => {
        set({ token: null, userId: null, username: null });
        localStorage.removeItem(AUTH_TOKEN);
        localStorage.removeItem(USER_ID);
        localStorage.removeItem(USER_NAME);
        localStorage.removeItem(AUTH_USER);
        window.location.href = "/auth/login";
      },
    }),
    {
      name: AUTH_STORAGE,
    }
  )
);
